###
# When display changes to a truthy value we open the modal. Then we wait for our
# dependencies to resolve from our ajax post. The user is then able to select
# submit or cancel, and a corresponding true or false value is placed into
# user-choice.
#
# The designed use case for this modal is when you are attempting to remove columns
# from a client's data warehouse. When doing this, there are many dependencies
# to those columns, that require user confirmation to delete.
# The endpoint that this was originally designed for is:
#  /v2/client/{cid#}/remoteDBConnection/{conn#} - edit post
#
#  <dependency-v2
#   display="openDependencyModal"
#   dependencies="dependenciesArrayComingBackFrom_editRemoteDBConnection"
#   user-choice="trueForSubmit_falseForCancel"></dependency-v2>
###
angular.module('rjmNg.directives').directive "dependencyV2", [
  () ->
    restrict: 'AE'
    templateUrl: "modal.dependencies.html"
    scope:
      display: '='
      dependencies: '='
      onConfirm: '&'
      onCancel: '&'
    link: (scope, el, attrs) ->

      scope.colState =
        ADDING: "Adding Columns"
        DEL: "Removing Columns With Dependencies"
        DEL_NODEPS: "Removing Columns With No Dependencies"

      setLoading = () ->
        scope.is =
          loading: true

      setContinue = () ->
        scope.is =
          continue: true

      setVerify = () ->
        scope.is =
          verify: true

      scope.$watch 'display', (newVal, oldVal) ->
        if newVal
          setLoading()
          $('#dependencyModal').modal()

      scope.$watch 'dependencies', (newVal, oldVal) ->
        if scope.dependencies?
          for userDependency in scope.dependencies.dependenciesByUserId
            userDependency.user.open = false

          scope.dep =
            cols: for notused_key,column of scope.dependencies.attemptedToAddColumns
              column._state = scope.colState.ADDING
              column
            users: scope.dependencies.dependenciesByUserId
  
          for notused_key,column of scope.dependencies.attemptedToRemoveColumns when column.id?
            scope.dep.cols.push column
          for notused_key,column of scope.dependencies.attemptedToRemoveDerivativeColumns when column.id?
            scope.dep.cols.push column

          for colum in scope.dep.cols
            if column.dependents
              column._state = scope.colState.DEL
            else
              column._state = scope.colState.DEL_NODEPS

          if _.size(scope.dep.cols) > 0
            setVerify()
          else
            setContinue()

      scope.makeUserChoice = (choice) ->
        # have to have this so that the modal closes before we make the choice
        $('#dependencyModal').modal('hide')
        if(choice)
          scope.onConfirm()
        else
          scope.onCancel()

      scope.toggle = (user) ->
        user.open = !user.open

      setLoading()
  ]
